module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6gCBj"))).then(() => parcelRequire('d0iPb'));